'use strict';

module.exports = {
    AWS: 'AWS',
    AZURE_ACCESS_KEY: 'AZURE_ACCESS_KEY'
};